import React, { useState } from 'react';

const NewsApi = () => {
  const [formData, setFormData] = useState({
    endpoint: 'top-headlines',
    country: 'us',
    category: '',
    q: '',
    sortBy: 'publishedAt',
    pageSize: '20',
    page: '1'
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const endpointOptions = [
    { value: 'top-headlines', label: 'Top Headlines (상위 헤드라인)' },
    { value: 'everything', label: 'Everything (전체 뉴스 검색)' }
  ];

  const countryOptions = [
    { value: 'us', label: 'US (미국)' },
    { value: 'gb', label: 'GB (영국)' },
    { value: 'kr', label: 'KR (한국)' },
    { value: 'jp', label: 'JP (일본)' },
    { value: 'cn', label: 'CN (중국)' },
    { value: 'de', label: 'DE (독일)' },
    { value: 'fr', label: 'FR (프랑스)' },
    { value: 'ca', label: 'CA (캐나다)' },
    { value: 'au', label: 'AU (호주)' },
    { value: 'in', label: 'IN (인도)' },
    { value: 'br', label: 'BR (브라질)' },
    { value: 'it', label: 'IT (이탈리아)' },
    { value: 'es', label: 'ES (스페인)' },
    { value: 'nl', label: 'NL (네덜란드)' },
    { value: 'ru', label: 'RU (러시아)' },
    { value: 'mx', label: 'MX (멕시코)' },
    { value: 'ar', label: 'AR (아르헨티나)' },
    { value: 'ch', label: 'CH (스위스)' },
    { value: 'se', label: 'SE (스웨덴)' },
    { value: 'no', label: 'NO (노르웨이)' }
  ];

  const categoryOptions = [
    { value: '', label: '전체 카테고리' },
    { value: 'business', label: 'Business (비즈니스)' },
    { value: 'entertainment', label: 'Entertainment (엔터테인먼트)' },
    { value: 'general', label: 'General (일반)' },
    { value: 'health', label: 'Health (건강)' },
    { value: 'science', label: 'Science (과학)' },
    { value: 'sports', label: 'Sports (스포츠)' },
    { value: 'technology', label: 'Technology (기술)' }
  ];

  const sortByOptions = [
    { value: 'publishedAt', label: 'Published At (발행일)' },
    { value: 'relevancy', label: 'Relevancy (관련성)' },
    { value: 'popularity', label: 'Popularity (인기도)' }
  ];

  const pageSizeOptions = [
    { value: '10', label: '10개' },
    { value: '20', label: '20개' },
    { value: '30', label: '30개' },
    { value: '40', label: '40개' },
    { value: '50', label: '50개' },
    { value: '60', label: '60개' },
    { value: '70', label: '70개' },
    { value: '80', label: '80개' },
    { value: '90', label: '90개' },
    { value: '100', label: '100개' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      // NewsAPI 호출을 위한 백엔드 API 엔드포인트
      const params = new URLSearchParams();
      params.append('endpoint', formData.endpoint);
      
      // 빈 값이 아닌 파라미터만 추가
      Object.entries(formData).forEach(([key, value]) => {
        if (value && value.trim() !== '' && key !== 'endpoint') {
          params.append(key, value.trim());
        }
      });


      const response = await fetch(`/api/news/dynamic?${params.toString()}`);
      const data = await response.json();

      if (data.success) {
        setResult(data);
      } else {
        console.error('❌ NewsAPI 오류 상세:', data);
        setError(data.message || 'API 호출 실패');
      }
    } catch (err) {
      console.error('❌ NewsAPI 동적 호출 실패:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="news-api-tester">
      <div className="page-header">
        <h1>NewsAPI 테스트</h1>
        <p>전 세계 뉴스를 검색하고 상위 헤드라인을 가져오는 API입니다.</p>
      </div>

      <div className="form-section">
        <h3>API 파라미터 설정</h3>
        <form onSubmit={handleSubmit}>
          <div className="parameters-grid">
            {/* 엔드포인트 선택 */}
            <div className="form-group">
              <label htmlFor="endpoint" className="required">엔드포인트:</label>
              <select
                id="endpoint"
                name="endpoint"
                value={formData.endpoint}
                onChange={handleInputChange}
                required
              >
                {endpointOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* 국가 선택 */}
            <div className="form-group">
              <label htmlFor="country">국가:</label>
              <select
                id="country"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
              >
                {countryOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* 카테고리 선택 */}
            <div className="form-group">
              <label htmlFor="category">카테고리:</label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
              >
                {categoryOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* 검색어 */}
            <div className="form-group">
              <label htmlFor="q">검색어:</label>
              <input
                type="text"
                id="q"
                name="q"
                value={formData.q}
                onChange={handleInputChange}
                placeholder="검색할 키워드를 입력하세요"
              />
            </div>

            {/* 정렬 방식 */}
            <div className="form-group">
              <label htmlFor="sortBy">정렬 방식:</label>
              <select
                id="sortBy"
                name="sortBy"
                value={formData.sortBy}
                onChange={handleInputChange}
              >
                {sortByOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* 페이지 크기 */}
            <div className="form-group">
              <label htmlFor="pageSize">페이지 크기:</label>
              <select
                id="pageSize"
                name="pageSize"
                value={formData.pageSize}
                onChange={handleInputChange}
              >
                {pageSizeOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* 페이지 번호 */}
            <div className="form-group">
              <label htmlFor="page">페이지 번호:</label>
              <input
                type="number"
                id="page"
                name="page"
                value={formData.page}
                onChange={handleInputChange}
                min="1"
                max="10"
                placeholder="1"
              />
            </div>
          </div>
          
          <div className="form-actions">
            <button 
              type="submit" 
              className="submit-button"
              disabled={loading}
            >
              {loading ? '실행 중...' : '실행'}
            </button>
          </div>
        </form>
      </div>

      {error && (
        <div className="error-section">
          <h3>❌ 오류</h3>
          <div className="error-message">{error}</div>
        </div>
      )}

      {result && (
        <div className="result-section">
          <div className="result-header">
            <h3>✅ API 호출 결과</h3>
          </div>
          
          <div className="result-info">
            <div className="info-item">
              <strong>엔드포인트:</strong> {result.endpoint}
            </div>
            <div className="info-item">
              <strong>총 결과 수:</strong> {result.result.totalResults}
            </div>
            <div className="info-item">
              <strong>실제 반환된 항목:</strong> {result.result.articles?.length || 0}개
            </div>
          </div>

          {/* 뉴스 목록 */}
          {result.result.articles && result.result.articles.length > 0 && (
            <div className="news-list">
              <h4>📰 뉴스 목록 ({result.result.articles.length}개)</h4>
              <div className="articles-grid">
                {result.result.articles.map((article, index) => (
                  <div key={index} className="article-item">
                    <div className="article-image">
                      {article.urlToImage && (
                        <img 
                          src={article.urlToImage} 
                          alt={article.title}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      )}
                    </div>
                    <div className="article-content">
                      <h5 className="article-title">
                        <a 
                          href={article.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          title="원문 보기"
                        >
                          {article.title}
                        </a>
                      </h5>
                      <p className="article-description">
                        {article.description}
                      </p>
                      <div className="article-meta">
                        <span className="article-source">{article.source?.name}</span>
                        <span className="article-date">{formatDate(article.publishedAt)}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="parameters-display">
            <div className="display-header">
              <h4>사용된 파라미터:</h4>
            </div>
            <pre>{JSON.stringify(result.params, null, 2)}</pre>
          </div>

          <div className="results-display">
            <div className="display-header">
              <h4>결과 데이터:</h4>
            </div>
            <pre>{JSON.stringify(result.result, null, 2)}</pre>
          </div>
        </div>
      )}

      {/* API 정보 섹션 */}
      <div className="api-info-section">
        <h3>📋 NewsAPI 정보</h3>
        <div className="api-info-content">
          <div className="info-group">
            <h4>🌍 서비스 규모</h4>
            <ul>
              <li><strong>뉴스 소스:</strong> 150,000개 이상의 전 세계 뉴스 소스</li>
              <li><strong>언어:</strong> 14개 언어 지원</li>
              <li><strong>국가:</strong> 55개국</li>
              <li><strong>기사 수:</strong> 수억 개의 기사</li>
            </ul>
          </div>
          
          <div className="info-group">
            <h4>🔧 API 특징</h4>
            <ul>
              <li><strong>REST API:</strong> JSON 형태의 결과 반환</li>
              <li><strong>실시간:</strong> 최신 뉴스 실시간 제공</li>
              <li><strong>검색 기능:</strong> 키워드, 날짜, 출판사별 필터링</li>
              <li><strong>무료 플랜:</strong> 일일 1,000회 요청 (개발용)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsApi;
